
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, ShoppingCart, Link } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';

interface ResellerPlansHeaderProps {
  onAddPlan: () => void;
}

const ResellerPlansHeader: React.FC<ResellerPlansHeaderProps> = ({ onAddPlan }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
      <div>
        <h1 className="text-3xl font-bold">Reseller Plans</h1>
        <p className="text-gray-500 mt-1">
          Configure and manage your reseller plans
        </p>
      </div>
      <div className="flex gap-3">
        <RouterLink to="/master/pending-orders">
          <Button variant="outline" className="flex items-center gap-2">
            <ShoppingCart className="h-4 w-4" />
            Manage Orders
          </Button>
        </RouterLink>
        <Button onClick={onAddPlan} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add New Plan
        </Button>
      </div>
    </div>
  );
};

export default ResellerPlansHeader;
